import React from 'react';
import PropTypes from 'prop-types';

import { Swiper } from '@ecp/common/src/components/swiper/bo/Swiper';
import { ImageViewItem, TabItem } from '@ecp/common/src/components/swiper/bo/component/SwiperItem';

export const SwiperTab = ({ ...props }) => {
  return <Swiper arrowProps={{ type: '8', position: 'outer' }} itemComponent={TabItem} {...props} />;
};

SwiperTab.displayName = 'SwiperTab';

SwiperTab.propTypes = {
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  arrowProps: PropTypes.object,
  itemComponent: PropTypes.elementType,
  onClick: PropTypes.func,
  carouselProps: PropTypes.object,
};

const SwiperTabDefaultProps = {
  carouselProps: {
    speed: 500,
    slidesPerView: 'auto',
    spaceBetween: 0,
    autoplay: false,
    loop: false,
    freeMode: { enabled: true, sticky: true },
    slideToClickedSlide: true,
    normalizeSlideIndex: false, //left 만 active 되지 않도록
    allowTouchMove: false,
  },
  itemProps: {
    width: 'fit-content',
    height: '36px',
  },
  width: '980px',
  height: '46px',
};

SwiperTab.defaultProps = {
  itemList: [],
  ...SwiperTabDefaultProps,
};

export const SwiperImageView = (props) => (
  <Swiper
    arrowProps={props.itemList.length > 1 ? { type: '32', position: 'inner' } : null}
    itemComponent={ImageViewItem}
    control={props.itemList.length > 1 ? 'outerLabel' : null}
    {...props}
  />
);

SwiperImageView.displayName = 'SwiperImageView';

SwiperImageView.propTypes = {
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  arrowProps: PropTypes.object,
  onClick: PropTypes.func,
  carouselProps: PropTypes.object,
};

export const SwiperImageViewDefaultProps = {
  carouselProps: {
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: false,
    loop: true,
    freeMode: { enabled: true, sticky: true },
    slideToClickedSlide: true,
    normalizeSlideIndex: true,
    allowTouchMove: false,
  },
  itemProps: {
    width: '640px',
    height: '580px',
  },
  width: '640px',
  height: '580px',
};

SwiperImageView.defaultProps = {
  itemList: [],
  itemProps: {},
  ...SwiperImageViewDefaultProps,
};
